module.exports = __webpack_public_path__ + "img/alarm.b3e53a0c.png";